import { toast } from "react-toastify";
import { Alert } from "@mui/material";

const buildToastId = (severity, msg) => {
  const normalizedMessage =
    typeof msg === "string" ? msg.trim() : String(msg ?? "");

  return `toast:${severity}:${normalizedMessage}`;
};

const buildOptions = (severity, msg, options) => {
  return {
    ...(options && { ...options }),
    ...(severity === "error" && {
      toastId: options?.toastId || buildToastId(severity, msg),
    }),
    hideProgressBar: true,
    closeButton: false,
    style: { padding: 0, borderRadius: 10, minHeight: 0 },
    bodyStyle: { padding: 0 },
  };
};

const customToast = {
  success(msg, options) {
    return toast(
      ({ closeToast }) => (
        <Alert severity="success" onClose={closeToast}>
          {msg}
        </Alert>
      ),
      buildOptions("success", msg, options)
    );
  },
  error(msg, options) {
    return toast(
      ({ closeToast }) => (
        <Alert severity="error" onClose={closeToast}>
          {msg}
        </Alert>
      ),
      buildOptions("error", msg, options)
    );
  },
  info(msg, options) {
    return toast(
      ({ closeToast }) => (
        <Alert severity="info" onClose={closeToast}>
          {msg}
        </Alert>
      ),
      buildOptions("info", msg, options)
    );
  },
  warning(msg, options) {
    return toast(
      ({ closeToast }) => (
        <Alert severity="warning" onClose={closeToast}>
          {msg}
        </Alert>
      ),
      buildOptions("warning", msg, options)
    );
  },
};

export { toast, customToast };
